import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { PlusSquareOutlined } from "@ant-design/icons";
import "swiper/css";
import "swiper/css/pagination";
import { Button } from "antd";
import ExpertArticlesSwiper from "./ExpertArticlesSwiper";
import { Pagination } from "swiper/modules";
import { useQuery } from "@tanstack/react-query";
import { getMyArticles } from "../../../../service/api";
import { useNavigate } from "react-router-dom";

function ExpertArticles() {

  const articlesQuery = useQuery(['expertArticles'], getMyArticles);
  const navigate = useNavigate()

  return (
    <div className="flex flex-col bg-white h-[540px] max-lg:!h-fit p-4 rounded-[10px] gap-2">
      {/* title */}
      <div className="text-right font-body text-[#005AC8] px-4 text-2xl font-bold">
        <h2>مقالات کارشناس</h2>
      </div>

      <div>
  <h2 className="font-body text-base mb-4  ">مطالب آموزشی خود را به صورت متن و تصویر در این بخش وارد کنید. این مطالب با نام خودتان به عنوان نویسنده در صفحه شخصی شما قرار خواهد گرفت. این بخش بیشترین تاثیر را در دیده شدن شما در بستر اینترنت و گوگل دارد.</h2>
</div>

      {/* swiper */}
      <div className=" h-[388px]">
        <Swiper
          dir="rtl"
          modules={[Pagination]}
          pagination={{
            dynamicBullets: true,
            clickable: true,
            renderBullet: function (index, className) {
              return (
                '<span class="' + className + '">' + (index + 1) + "</span>"
              );
            },
          }}
          breakpoints={{
            320: {
              slidesPerView: 1.1,
              spaceBetween: 10,
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            640: {
              slidesPerView: 3.2,
              spaceBetween: 32,
            },
            1600: {
              slidesPerView: 3.2,
              spaceBetween: 32,
            },
          }}
          style={{ paddingBottom: "3rem" }}
        >
          {articlesQuery?.data?.map((article, i) => (
            <SwiperSlide style={{ width: "100%" }} key={i}>
              {<ExpertArticlesSwiper article={article} />}
            </SwiperSlide>)
          )}
        </Swiper>
      </div>

      {/* add new button */}
      <div className="text-left px-4 ">
        <Button
          onClick={()=> navigate('/content-management/article')}
          className="bg-gradient-to-r from-blue-800 to-sky-600 text-white "
          icon={<PlusSquareOutlined />}
        >
          افزودن جدید
        </Button>
      </div>
    </div>
  );
}

export default ExpertArticles;
